import { useState } from "react";
import { Box, Input } from "@chakra-ui/react";

const DateInput = ({ placeholder, value, onChange, color = "gray.900", w, flex, ...inputProps }) => {
    const [focused, setFocused] = useState(false);
    const showPlaceholder = !focused && !value;
    return (
        <Box position="relative" display="flex" alignItems="center" w={w} flex={flex}>
            <Input
                type="date"
                value={value}
                onChange={onChange}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                bg="white"
                borderColor="gray.200"
                color={showPlaceholder ? "transparent" : color}
                w="full"
                {...inputProps}
            />
            {showPlaceholder && (
                <Box
                    position="absolute"
                    left={4}
                    pointerEvents="none"
                    color="gray.400"
                    fontSize="sm"
                    zIndex={1}
                >
                    {placeholder}
                </Box>
            )}
        </Box>
    );
};

export default DateInput;
